import { ISearchParams, ISearchResult, IState } from "./state";
import { ActionTree, Store, ActionContext } from 'vuex';
import qs from 'query-string';
import * as api from '../api';

type PayloadType = 'initApp' | 'setState' | 'newSearch' | 'focusFirstItem'
export type ActionPayload<ActionData> = {
	type: PayloadType,
	payload: ActionData
}

type ActionHandler<ActionData> = (this: Store<IState>, injectee: ActionContext<IState, IState>, payload: ActionPayload<ActionData>) => any;
type ActionCreator<ActionData> = (data: ActionData) => ActionPayload<ActionData>;


// Action creators
export const initApp: ActionCreator<IState> = (state) => ({
	type: 'initApp',
	payload: state
})

export const newSearch: ActionCreator<null> = () => ({
	type: 'newSearch',
	payload: null,
})

export const focusFirstItem: ActionCreator<null> = () => ({
	type: 'focusFirstItem',
	payload: null,
})

// Action handlers
const initAppAction: ActionHandler<IState> = ({ commit }, { payload }) => {
	commit({
		type: 'setState',
		payload
	})
}

const newSearchAction: ActionHandler<void> = ({ commit, state }) => {
	commit({
		type: 'setLoading',
		payload: true,
	});
	
	const params: ISearchParams = {
		query: state.query,
		page: state.page,
		board: state.selectedBoard,
		party: state.selectedParty,
	}

	api.search(state.searchUrl, params)
		.then((res:ISearchResult) => {
			commit({
				type: 'setHits',
				payload: res.hits,
			});
			commit({
				type: 'setTotal',
				payload: res.total,
			});
			commit({
				type: 'setLoading',
				payload: false,
			});
		})
	
	const url:string = `${window.location.protocol}//${window.location.host + window.location.pathname}?${qs.stringify(params, { skipEmptyString:true })}`;
    window.history.replaceState({}, document.title, url);
}

const focusFirstItemAction: ActionHandler<void> = ({ commit, state }) => {
	const hit = state.hits[0];
	if(hit) {
		const hitElement: HTMLElement | null = document.querySelector('#politician-' + hit.id);
		if(hitElement) {
			hitElement.focus();
		}
	}
}

const actions: ActionTree<IState, IState> = {
	initApp: initAppAction,
	newSearch: newSearchAction,
	focusFirstItem: focusFirstItemAction
}

export default actions;
